export const tdcj = {
    agencyCode: '696',
    name: 'Texas Department of Criminal Justice',
    shortName: 'tdcj',
    slug: 'tdcj',
  };
  